import React, { Component } from "react";
import PropTypes from "prop-types";

export default class ReLogin extends Component {
  refresh(e) {
    e.preventDefault();
    window.location.reload();
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        {children}{" "}
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          Refresh
        </a>{" "}
        the page to try again.
      </div>
    );
  }
}

ReLogin.propTypes = {
  children: PropTypes.node
};
